import {FormControl, InputLabel, MenuItem, Select} from "@mui/material";
import {memo, useMemo} from "react";


export default memo(function APXNumberSelector({title, min = 1, max = 20, value, onChange}) {
    const numbers = useMemo(() => Array.from({length: max - min + 1}, (_, i) => i + min), [min, max]);
    return (
        <FormControl fullWidth variant="outlined">
            <InputLabel>{title}</InputLabel>
            <Select
                value={value}
                onChange={onChange}
                label={title}
            >
                {
                    numbers.map((number) => (
                        <MenuItem key={number} value={number}>
                            {number}
                        </MenuItem>
                    ))
                }
            </Select>
        </FormControl>
    );
});